import { SwimProofMethodDTO } from "../dto/SwimProofMethodDTO";
import { SwimProof } from "../models/SwimProof";

export const swimProofMapper = (dto: SwimProofMethodDTO): SwimProof => {
  return new SwimProof({
    id: dto.methodId,
    name: dto.methodName,
    active: dto.active === "Y",
  });
};
